// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ClientesPreencher_GetPublicTokenResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/preencher/{token}
 *
 * Public endpoint — returns minimal info to render the public form.
 * Only exposes the customer name for confirmation; no other data leaks.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ClientesPreencher_GetPublicTokenResponseDados {
cliente_nome?: string
is_valid?: boolean
error_message?: string
locale?: string
document_type?: string
document_label?: string
document_mask?: string
country?: string
has_postal_code?: boolean
}

export type ClientesPreencher_GetPublicTokenResponse = ApiResponse<ClientesPreencher_GetPublicTokenResponseDados>;

registerResponseContract('ClientesPreencher_GetPublicTokenResponse', {
  cliente_nome:    { type: 'string',  required: false },
  is_valid:        { type: 'boolean', required: false },
  error_message:   { type: 'string',  required: false },
  locale:          { type: 'string',  required: false },
  document_type:   { type: 'string',  required: false },
  document_label:  { type: 'string',  required: false },
  document_mask:   { type: 'string',  required: false },
  country:         { type: 'string',  required: false },
  has_postal_code: { type: 'boolean', required: false },
})
